import { render, staticRenderFns } from "./SettingsHome.vue?vue&type=template&id=e59b7ec6&"
import script from "./SettingsHome.vue?vue&type=script&lang=js&"
export * from "./SettingsHome.vue?vue&type=script&lang=js&"
import style0 from "./SettingsHome.vue?vue&type=style&index=0&id=e59b7ec6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports